var React = require('react');

function InfoBlue (props) {
    return React.createElement("svg",props,[React.createElement("circle",{"cx":"8","cy":"8","r":"8","fill":"#015BBB","key":0}),React.createElement("path",{"d":"M8 7H7.5C7.36739 7 7.24021 7.05853 7.14645 7.16272C7.05268 7.26691 7 7.40821 7 7.55556C7 7.7029 7.05268 7.84421 7.14645 7.94839C7.24021 8.05258 7.36739 8.11111 7.5 8.11111H8V11.4444C8 11.5918 8.05268 11.7331 8.14645 11.8373C8.24021 11.9415 8.36739 12 8.5 12C8.63261 12 8.75979 11.9415 8.85355 11.8373C8.94732 11.7331 9 11.5918 9 11.4444V8.11111C9 7.81643 8.89464 7.53381 8.70711 7.32544C8.51957 7.11706 8.26522 7 8 7Z","fill":"white","key":1}),React.createElement("path",{"d":"M8 6C8.55228 6 9 5.55228 9 5C9 4.44772 8.55228 4 8 4C7.44772 4 7 4.44772 7 5C7 5.55228 7.44772 6 8 6Z","fill":"white","key":2})]);
}

InfoBlue.defaultProps = {"width":"16","height":"16","viewBox":"0 0 16 16","fill":"none"};

module.exports = InfoBlue;

InfoBlue.default = InfoBlue;
